import axios from 'axios';

const API_URL = 'https://pleasant-fascination-production.up.railway.app/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('ess_token');
  return token ? { Authorization: 'Bearer ' + token } : {};
};

// Auth
export const essLogin = async (email, password) => {
  const response = await axios.post(API_URL + '/auth/ess-login', { email, password });
  return response.data;
};

// Helper to extract data from response
const extractData = (response) => {
  if (response?.data?.data) return { data: response.data.data };
  if (response?.data) return { data: response.data };
  return { data: [] };
};

// Data endpoints - using main app collections
export const getEmployees = async () => {
  const response = await axios.get(API_URL + '/data/ess/employees', { headers: getAuthHeaders() });
  return extractData(response);
};

export const getCustomers = async () => {
  const response = await axios.get(API_URL + '/data/ess/customers', { headers: getAuthHeaders() });
  return extractData(response);
};

export const getFacilities = async () => {
  const response = await axios.get(API_URL + '/data/ess/facilities', { headers: getAuthHeaders() });
  return extractData(response);
};

export const getServices = async () => {
  const response = await axios.get(API_URL + '/data/ess/services', { headers: getAuthHeaders() });
  return extractData(response);
};

export const getSupplierPricing = async () => {
  const response = await axios.get(API_URL + '/data/ess/suppliers', { headers: getAuthHeaders() });
  return extractData(response);
};

export const getWorkOrders = async () => {
  const response = await axios.get(API_URL + '/data/ess/workorders', { headers: getAuthHeaders() });
  return extractData(response);
};

export const createWorkOrder = async (data) => {
  const response = await axios.post(API_URL + '/data/ess/workorders', data, { headers: getAuthHeaders() });
  return response.data;
};

export const getInternalOrders = async () => {
  const response = await axios.get(API_URL + '/data/ess/internalorders', { headers: getAuthHeaders() });
  return extractData(response);
};

export const createInternalOrder = async (data) => {
  const response = await axios.post(API_URL + '/data/ess/internalorders', data, { headers: getAuthHeaders() });
  return response.data;
};

export const getLeaveRequests = async () => {
  const response = await axios.get(API_URL + '/data/ess/leaverequests', { headers: getAuthHeaders() });
  return extractData(response);
};

export const createLeaveRequest = async (data) => {
  const response = await axios.post(API_URL + '/data/ess/leaverequests', data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteLeaveRequest = async (id) => {
  const response = await axios.delete(API_URL + '/data/ess/leaverequests/' + id, { headers: getAuthHeaders() });
  return response.data;
};

export const getDispatchLog = async () => {
  const response = await axios.get(API_URL + '/data/ess/dispatches', { headers: getAuthHeaders() });
  return extractData(response);
};

// Assigned tasks (work orders dispatched to this employee)
export const getAssignedTasks = async () => {
  const response = await axios.get(API_URL + '/data/ess/assignedtasks', { headers: getAuthHeaders() });
  return extractData(response);
};

export const updateAssignedTask = async (id, data) => {
  const response = await axios.patch(API_URL + '/data/ess/assignedtasks/' + id, data, { headers: getAuthHeaders() });
  return response.data;
};

export const getWorkDocuments = async () => {
  const response = await axios.get(API_URL + '/data/ess/documents', { headers: getAuthHeaders() });
  return extractData(response);
};

export const createWorkDocument = async (data) => {
  const response = await axios.post(API_URL + '/data/ess/documents', data, { headers: getAuthHeaders() });
  return response.data;
};

export const getMyPayslips = async (employeeId) => {
  const response = await axios.get(API_URL + '/data/ess/payslips/' + employeeId, { headers: getAuthHeaders() });
  return extractData(response);
};
